import { ProductApi } from '@/modules/product/core/api'
import { UserApi } from '@/modules/user/core/api'
import { WxApi } from '@/modules/user/core/wxApi'

export class BTApi {
    wx = new WxApi();
    product = new ProductApi();
    user = new UserApi();
}
